const base64UrlDecode = (segment: string): string => {
  const base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')
  return atob(padded)
}

export const parseJwtExp = (token: string): number | null => {
  const segments = token.split('.')
  if (segments.length < 2 || !segments[1]) {
    return null
  }
  try {
    const payload = JSON.parse(base64UrlDecode(segments[1]))
    return typeof payload.exp === 'number' ? payload.exp : null
  } catch {
    return null
  }
}
